module.exports = __webpack_public_path__ + "img/pesto_done.8ee00fbf.jpg";